// JavaScript Document
// Version: 1.0.0

var page = {
	tip: 2,
	gallery: 2,
	partner: 2,
	event: 2
};
var context;
var target;
var postType;
var numberPosts;
var loadMoreButton;
var searchBy;
var searchFounds;
var totalPosts;

jQuery(document).ready(function($) {
	var noMoreResults  = false;
	
	
	
	/**
     * Carica nuovi elementi.
     *
	 * @since 1.0.0
     */
	$('.btn-load-more').on('click', function() {
		var that = $(this);
		
		loadMoreButton = that;
		target         = that.data('target');
		context        = that.data('context');
		postType       = that.data('post-type');
		numberPosts    = that.data('number-posts');
		searchBy       = that.data('search-by');
		searchFounds   = that.data('search-founds');
		totalPosts     = that.data('total-posts');
		
		if ( !noMoreResults ) {
			that.blur();
			loadMorePosts(loadMoreButton);
		} else {
			//...
		}		
	});
    
});



/**
 * Carica nuovi elementi.
 *
 * @param  {selector} loadMoreButton
 *
 * @return {void}
 *
 * @since 1.0.0
 */
function loadMorePosts(loadMoreButton) {
	displayLoading(true, loadMoreButton);
	
	var wrapper = jQuery('.load-more-wrapper#' + target);
	
	console.log({
		page: page[postType],
		posts_per_page: numberPosts,
		total_posts: totalPosts
	});
	
	jQuery.ajax({
		url: mst_vars.ajax_url,
		type: 'POST',
		dataType: 'json',
		data: {
			action: 'search_infinite_scroll',
			_nonce: mst_vars.nonce,
			page: page[postType],
			context: context,
			target: target,
			post_type: postType,
			posts_per_page: numberPosts,
			search_by: searchBy,
			search_founds: searchFounds,
			post_ids: getPostIds(),
			search_term: mst_vars.search_term,
			lang: mst_vars.lang
		},
		success: function (response) {
			if (response.success) {
				if ('data' in response && '' != response.data) {
					var items = jQuery.map(response.data, function(element, index) {
						return jQuery.trim(element.replace(/\r?\n|\r/g, ''));
					});

					jQuery.each(items, function(index, element) {
						wrapper.append(jQuery(element));
					});

					page[postType] = page[postType] + 1;
					console.log(page[postType]);

					displayLoading(false, loadMoreButton);
					
					if ( jQuery('.load-more-item', wrapper).length == totalPosts ) {
						jQuery(loadMoreButton).attr('disabled', true).fadeOut();
					} else {
						jQuery(loadMoreButton).attr('disabled', false).fadeIn();
					}
				} else {
					displayLoading(false, loadMoreButton);
					jQuery(loadMoreButton).attr('disabled', true).fadeOut();
				}
			} else {
				console.log(response);
			}				
		},
		error: function(xhrRequest, status, errorMessage) {
			displayLoading(false, loadMoreButton);
			console.log(xhrRequest);
		}
	});
}



/**
 * Mostra il loader.
 *
 * @param {bool} show
 *
 * @since 1.0.0
 */
function displayLoading(show, loadMoreButton) {
	var wrapper = jQuery('.load-more-wrapper#' + jQuery(loadMoreButton).data('target'));
	
	if ( show ) {
		jQuery(wrapper).addClass('loading');
		jQuery(loadMoreButton).text(jQuery(loadMoreButton).data('text-loading'));
	} else {
		jQuery(wrapper).removeClass('loading');
		jQuery(loadMoreButton).text(jQuery(loadMoreButton).data('text-default'));
	}
	
	jQuery(loadMoreButton).attr('disabled', show);
}



/**
 * Recupera eventuali parametri passati via query string nell'url.
 *
 * @param  {string} name : chiave della query string da recuperare
 * @return {*}           : valore associato alla chiave della query string
 *
 * @since 1.0.0
 */
function urlParam(name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

	return ( results == null ) ? null : results[1] || 0;
}



/**
 * Restituisce gli id degli elementi.
 *
 * @return {array}
 *
 * @since 1.1.0
 */
function getPostIds() {
	var context = jQuery('.load-more-wrapper#' + target);
	
	return jQuery.map(jQuery('.type-' + postType, context), function(element, index) {
		return parseInt(jQuery(element).attr('id').replace('post-', ''));
	});
}

